let cachedSquad = null;
export function getSquad() {
  if (cachedSquad) return Promise.resolve(cachedSquad);
  return fetch('/rss-proxy.php?feed=squad').then(r => r.json()).then(data => {
    cachedSquad = data;
    return data;
  }).catch(() => {
    return {
      mv: [],
      fb: [],
      mf: [],
      af: []
    };
  });
}
export function getPlayersForGroup(squad, group) {
  return squad[group] || [];
}
flarum.reg.add('ois-lineup', 'forum/utils/squadApi', { getSquad: getSquad,getPlayersForGroup: getPlayersForGroup, });